import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslations } from '../hooks/useTranslations';
import { getBasePathFromUrlPath, getLanguageFromUrlPath, isSupportedLanguage } from '../utils/localizedRoutes';

export function LanguageSync() {
  const location = useLocation();
  const { currentLanguage, changeLanguage } = useTranslations();

  useEffect(() => {
    const pathLanguage = getLanguageFromUrlPath(location.pathname);
    const basePath = getBasePathFromUrlPath(location.pathname);
    const legacyQueryLang = new URLSearchParams(location.search).get('lang');
    const nextLanguage =
      pathLanguage ||
      (isSupportedLanguage(legacyQueryLang) ? legacyQueryLang : null) ||
      (basePath ? 'en' : null);

    if (nextLanguage && nextLanguage !== currentLanguage) {
      changeLanguage(nextLanguage);
    }
  }, [location.pathname, location.search, currentLanguage, changeLanguage]);

  return null;
}
